if (!customElements.get('price-range-slider')) {
  class PriceRangeSlider extends HTMLElement {
    constructor() {
      super();
      this.rangeMin = this.querySelector('.price-slider__range--min');
      this.rangeMax = this.querySelector('.price-slider__range--max');
      this.inputMin = this.querySelector('[data-role="input-min"]');
      this.inputMax = this.querySelector('[data-role="input-max"]');
      this.labelMin = this.querySelector('[data-role="label-min"]');
      this.labelMax = this.querySelector('[data-role="label-max"]');
      this.track = this.querySelector('.price-slider__track');
      this.debounceTimer = null;

      this.min = Number(this.dataset.min) || 0;
      this.max = Number(this.dataset.max) || 10000;

      this.rangeMin.addEventListener('input', () => this.onRangeSlide('min'));
      this.rangeMax.addEventListener('input', () => this.onRangeSlide('max'));
      this.rangeMin.addEventListener('change', () => this.onCommit());
      this.rangeMax.addEventListener('change', () => this.onCommit());

      this.inputMin.addEventListener('change', () => this.onInputChange('min'));
      this.inputMax.addEventListener('change', () => this.onInputChange('max'));
      this.inputMin.addEventListener('keydown', (e) => this.onKeyDown(e));
      this.inputMax.addEventListener('keydown', (e) => this.onKeyDown(e));

      this.sync();
    }

    onKeyDown(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.target.dispatchEvent(new Event('change'));
      }
      const allowed = /[0-9]|Backspace|Tab|ArrowLeft|ArrowRight|Delete|Enter/;
      if (!e.key.match(allowed) && !e.metaKey && !e.ctrlKey) e.preventDefault();
    }

    onRangeSlide(handle) {
      let lo = Number(this.rangeMin.value);
      let hi = Number(this.rangeMax.value);

      if (lo > hi) {
        if (handle === 'min') { this.rangeMin.value = hi; lo = hi; }
        else { this.rangeMax.value = lo; hi = lo; }
      }

      this.inputMin.value = lo;
      this.inputMax.value = hi;
      this.labelMin.textContent = lo;
      this.labelMax.textContent = hi;
      this.updateTrack(lo, hi);
    }

    onInputChange(handle) {
      let lo = Number(this.inputMin.value) || 0;
      let hi = Number(this.inputMax.value) || this.max;

      lo = Math.max(this.min, Math.min(lo, this.max));
      hi = Math.max(this.min, Math.min(hi, this.max));
      if (lo > hi) { if (handle === 'min') lo = hi; else hi = lo; }

      this.inputMin.value = lo;
      this.inputMax.value = hi;
      this.rangeMin.value = lo;
      this.rangeMax.value = hi;
      this.labelMin.textContent = lo;
      this.labelMax.textContent = hi;
      this.updateTrack(lo, hi);
      this.scheduleSubmit();
    }

    onCommit() {
      const lo = Number(this.rangeMin.value);
      const hi = Number(this.rangeMax.value);
      this.inputMin.value = lo;
      this.inputMax.value = hi;
      this.labelMin.textContent = lo;
      this.labelMax.textContent = hi;
      this.updateTrack(lo, hi);
      this.scheduleSubmit();
    }

    sync() {
      const lo = Number(this.rangeMin.value);
      const hi = Number(this.rangeMax.value);
      this.updateTrack(lo, hi);
    }

    updateTrack(lo, hi) {
      const range = this.max - this.min;
      if (range <= 0) return;
      const leftPct = ((lo - this.min) / range) * 100;
      const rightPct = ((hi - this.min) / range) * 100;
      this.track.style.setProperty('--range-left', leftPct + '%');
      this.track.style.setProperty('--range-right', rightPct + '%');
    }

    scheduleSubmit() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        const form = this.closest('form');
        if (form) form.dispatchEvent(new Event('input', { bubbles: true }));
      }, 600);
    }
  }

  customElements.define('price-range-slider', PriceRangeSlider);
}
